/*
    Implements Combobox UI element
    использовался в реализации чата, скорее всего не работает и требует допиливания, добавлен в проект только как зависимость для класса UIMessages

 */

export class UICombobox {

    /*
        container - HtmlElement
        items - array of struct {name, value}
        [options.id]
        [options.defaultValue]
        [options.changeCallback]
     */
    constructor(container, items, options) {
        this.container = container;
        this.container.innerHTML = '<div class="__select __select__expand_up __my" data-state="">' +
            '<div class="__select__title">Option 0</div>' +
            '<div class="__select__content"></div>' +
            '</div>';
        this.titleElement = this.container.querySelector('.__select__title');
        this.selectElement = this.container.querySelector('.__select');
        this.listContainerElement = this.container.querySelector('.__select__content');
        this.id = "selectExample";
        if (options) {
            if (options.id)
                this.id = options.id;
            this.changeCallback = options.changeCallback;
            this.defaultValue = options.defaultValue;
        }

        items.forEach(function (el) {
            this.addElement(el.name, el.value)
        }.bind(this));

        // Toggle menu
        this.titleElement.addEventListener('click', function () {
            let curState = this.selectElement.getAttribute('data-state');
            this.selectElement.setAttribute('data-state', curState === 'active' ? '' : 'active');
        }.bind(this));

        this._default();
    }

    addElement(name, value) {
        let itemsElements = this._labelItems();
        let curItemNo = itemsElements.length;
        let itemId = `${this.id}${curItemNo}`;
        let html = `<input id="${itemId}" class="__select__input" type="radio" name="${this.id}" value="${value}"/><label for="${itemId}" class="__select__label">${name}</label>`;
        if (curItemNo == 0) {
            this.listContainerElement.innerHTML = html;
        } else {
            itemsElements[curItemNo-1].insertAdjacentHTML("afterend", html);
        }

        // Close when click to option
        this._labelItemElement(itemId).addEventListener('click', function(e) {
            this.select(document.getElementById(e.target.getAttribute("for")).value);
        }.bind(this));
    }

    removeAll() {
        while (this.listContainerElement.lastElementChild) {
            this.listContainerElement.removeChild(this.listContainerElement.lastElementChild);
        }
    }

    _labelItems() {
        return this.selectElement.querySelectorAll('.__select__label');
    }

    //get labelItemElement for itemId
    _labelItemElement(id) {
        return this.listContainerElement.querySelector(`[for="${id}"]`)
    }

    _inputItems() {
        return this.selectElement.querySelectorAll('.__select__input');
    }

    _default() {
        //let def =
    }

    select(value) {
        for (let el of this._inputItems()) {
            if (el.value == value) {
                el.checked = true;
                let label = this._labelItemElement(el.id);
                this.titleElement.textContent = label.textContent;
                this.selectElement.setAttribute('data-state', '');
                if (this.changeCallback)
                    this.changeCallback(value);
                break
            }
        }
    }
}
